import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import VenusLogo from "../components/VenusLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Landing route for `/boutique` (no slug). Fetches the default tenant
 * slug from the backend then redirects to `/boutique/:slug`.
 * Used to give clients a short, brandable URL like:
 *   https://venusmedical.sn/boutique
 */
export default function PublicCatalogDefault() {
  const [slug, setSlug] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/public/default-slug`);
        if (data?.slug) setSlug(data.slug);
        else setError("Boutique indisponible");
      } catch (e) {
        setError(e.response?.data?.detail || "Boutique indisponible");
      }
    })();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <VenusLogo size={64} className="mx-auto rounded-2xl mb-4" />
          <h1 className="font-heading text-2xl font-bold mb-2">Boutique indisponible</h1>
          <p className="text-[var(--text-muted)]">{error}</p>
        </div>
      </div>
    );
  }

  if (!slug) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--text-muted)] font-data">
        Chargement de la boutique...
      </div>
    );
  }

  return <Navigate to={`/boutique/${slug}`} replace />;
}
